import React from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { useLocation } from "react-router";
import { ChevronLeft } from "@mui/icons-material";
import { Box, Button, Tab, Tabs } from "@mui/material";

import { WardBeds } from "../WardBeds";
import { WardType } from "../../../../constants/ward";
import { WardAdmissions } from "../WardAdmissions";

const TABS = {
  BEDS: "beds",
  PATIENTS: "patients"
} as const;

// eslint-disable-next-line import/prefer-default-export
export function SurgicalWardsLayout(): React.ReactNode {
  const dispatch = useDispatch();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const selectedTab = searchParams.get("tab") ?? TABS.BEDS;

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    searchParams.set("tab", newValue);

    if (newValue === TABS.PATIENTS) {
      searchParams.set("status", "admitted");
    } else {
      searchParams.delete("status");
      searchParams.delete("ipdId");
    }

    dispatch(
      push({
        pathname: location.pathname,
        search: searchParams.toString()
      })
    );
  };

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        sx={{
          height: "50px",
          borderBottom: 1,
          borderColor: "divider"
        }}
      >
        <Tab label="Beds" value={TABS.BEDS} />
        <Tab label="Patients" value={TABS.PATIENTS} />

        <Button
          sx={{ ml: "auto", px: 2 }}
          size="small"
          onClick={() => dispatch(push("/ipd/dashboard"))}
        >
          <ChevronLeft /> Back
        </Button>
      </Tabs>

      <Box sx={{ height: "calc(100vh - 100px)" }}>
        {selectedTab === TABS.BEDS && <WardBeds wardType={WardType.SURGICAL} />}
        {selectedTab === TABS.PATIENTS && <WardAdmissions wardType={WardType.SURGICAL} />}
      </Box>
    </>
  );
}
